import { View } from '@amzn/stencil-react-components/layout';

/**
 * Thin vertical separator line using Stencil border + spacing tokens.
 * The inline sibling of `Divider` — use it inside a `Row` to separate two
 * inline items (e.g. a field label from a trailing info-tooltip icon).
 *
 * Rendered as a filled thin box (not a `borderLeft` on a zero-width element,
 * which collapses in a flex row). `flexShrink: 0` stops the row from squeezing
 * it away. Height is a spacing token so it spans one line of label text.
 */
export function VerticalDivider(): JSX.Element {
  return (
    <View
      aria-hidden="true"
      css={{
        width: 'var(--st-dt-dimensions-border-width-100)',
        height: 'var(--st-dt-dimensions-spacing-350)',
        backgroundColor: 'var(--st-dt-color-border-primary)',
        flexShrink: 0,
      }}
    />
  );
}
